// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b4-3";
export var contentContainer = "_b4-0";
export var editorContainer = "_b4-1";
export var quillInputForm = "_b4-2";
export var zoneDivider = "_b4-4";